import React from 'react';
import PropTypes from 'prop-types';
import css from './css/RadioButtonWithoutLabel.scss'

const RadioButtonWithoutLabel = ({ disabled, ...inputProps }) => {
    return (
        <div className={css['radiobutton-wrapper']}>
            <label className={`${css['radiobutton']} ${disabled ? css['disabled'] : ''}`}>
                <input type="radio" disabled={disabled} {...inputProps} />
            </label>
        </div>
    )
}

RadioButtonWithoutLabel.propTypes = {
    value: PropTypes.any.isRequired,
    name: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool
}
export default RadioButtonWithoutLabel
